"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parsePath = parsePath;
exports.parseQueryString = parseQueryString;

var _pathToRegexp = _interopRequireDefault(require("path-to-regexp"));

var _querystringify = _interopRequireDefault(require("querystringify"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;

function compilePath(path) {
  if (cache[path]) return cache[path];
  var keys = [];
  var regexp = (0, _pathToRegexp.default)(path, keys);
  var result = {
    regexp: regexp,
    keys: keys
  };

  if (cacheCount < cacheLimit) {
    cache[path] = result;
    cacheCount++;
  }

  return result;
}

function parsePath(pathname, path) {
  var _compilePath = compilePath(path),
      regexp = _compilePath.regexp,
      keys = _compilePath.keys;

  var match = regexp.exec(pathname);
  if (!match) return null;

  var _match = _toArray(match),
      url = _match[0],
      values = _match.slice(1);

  return keys.reduce(function (memo, key, index) {
    memo[key.name] = values[index];
    return memo;
  }, {});
}

function parseQueryString(queryString) {
  var queryStringParams = _querystringify.default.parse(queryString);

  for (var key in queryStringParams) {
    if (queryStringParams[key] === 'null') {
      queryStringParams[key] = null;
    } else if (queryStringParams[key] === 'undefined') {
      queryStringParams[key] = undefined;
    }
  }

  return queryStringParams;
}